
// @ts-nocheck
//此页面代码没有与gametool保持完全一致
import { Options, Vue } from "vue-class-component"; //基本需要\
import { reactive, ref } from "vue";
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import Bs from "@/components/WorkBench/SideMenu1.vue"; //导入组件SideMenu:1
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import { ElMessage } from "element-plus";
import * as echarts from "echarts";
import { store } from "@/store"; //引入仓库
import {
  readDateVersions,
  readNewReport,
  readNewReportList,
  readPerfReport,
  readRecentTaskrecord,
  readPerformanceVersion,
  readGetPkgResourceList,
  readGetPkgResourceReport,
  readGetPkgResourceSum,
  readGetPkgResourceRate,
  readGetPkgStructTrend,
  readGetPerfettoOptions,
  readGetPerfettoTypeOptions,
  readGetPerfettoDeviceOptions,
  readGetPerfettoReport,
  readGetPerfettoLevelOptions,
  readGetPerfettoDeviceOptionsTrend,
  readGetPerfettoNativeTrend,
  readGetPerfettoNativeFuncTrend,
  readGetPerfettoDeviceOptionsImportant,
  readGetPerfettoSceneOptions,
  readGetPerfettoLevelOptionsImportant,
  readGetPerfettoNativeModule,
  readGetPerfettoNativeAll,
  readGetPerfettoSettings,
  readGetPerfettoSoAll,
  readGetPerfettoSoList,
  readGetPerfettoSoFuncTrend,
  readGetPerfettoStack,
  readGetPerfettoStackSearch,
  readGetPerfettoStackSearchV2,
  readGetPerfettoStackSearchFunctions,
  readGetPerfettoStackSearchSo,
  readGetPerfeformanceOldDate,
  readGetPerfettoModuleTrend,
  readGetPerfettoModuleList,
} from "@/store/performance/getters"; //引入仓库接口
import {
  dispatchPerfettoOptions,
  dispatchPerfettoSettings,
  dispatchPerfettoDeviceOptions,
  dispatchPerfettoDeviceOptionsTrend,
  dispatchPerfettoDeviceOptionsImportant,
  dispatchPerfettoLevelOptionsImportant,
  dispatchPerfettoReport,
  dispatchPerfettoNativeModule,
  dispatchPerfettoSceneOptions,
  dispatchPerfettoNativeTrend,
  dispatchPerfettoLevelOptions,
  dispatchUploadPerfettoReport,
  dispatchPerfettoText,
  dispatchPerfettoSettingsEdit,
  dispatchPerfettoOptionsOld,
  dispatchPerfettoMap,
  dispatchPerfettoTypeOptions,
  dispatchPerfettoNativeFuncTrend,
  dispatchPerfettoTraces,
  dispatchDeletePerfetto,
  dispatchPerfettoNativeAll,
  dispatchPerfettoNativeAllExport,
  dispatchPerfettoSoAll,
  dispatchPerfettoSoList,
  dispatchPerfettoSoFuncTrend,
  dispatchPerfettoStack,
  dispatchPerfettoStackSearch,
  dispatchPerfettoStackSearchV2,
  dispatchPerfettoStackSearchFuncitons,
  dispatchPerfettoStackSearchSo,
  dispatchPerfettoDownLoadStack,
  dispatchPerfettoFileName,
  dispatchPerfettoOldOptions,
  dispatchPerfettoModuleTrend,
  dispatchPerfettoModuleList,
} from "@/store/performance/actions";
import { importProfile, Viewer } from "speedscope";
import { readDeviceSpecs } from "@/store/device/getters";
import { dispatchGetDeviceSpecs } from "@/store/device/actions";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import _FormItem from "element-plus/lib/el-form-item";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";
import axios from 'axios'
import {grAxios} from '@/utils'

const useStackTable = { //内存堆栈对比table
  data() {
    return {
      stackType: 'tree',
      allStackData: {},
      stackTableKey: Math.random(),
      stackTableData: [],
    }
  },

  computed: {
    // stackTableData() {
    //   const data = this.allStackData?.[this.stackType] || {}
    //   //this.handleStackData(data)
    //   return data ? [data] : []
    // }
  },

  watch: {
    perfettoStack_v2() {
      this.stackTableKey = Math.random()
      this.allStackData =  this.perfettoStack_v2 || {}
    }
  },

  methods: {
    loadStackChildren(row, treeNode, resolve) {
      resolve(row.child)
    },

    async getStackTableData() {
      let params = {
        //level: this.level_stack,
        // date: this.version_list.filter((v) => v.name == this.dateName)[0].date,
        // version: this.version_list.filter((v) => v.name == this.dateName)[0].version,
        // type: this.type,
        // scene_name: this.scene_stack_id,
        // size: this.flame_size_stack_input,
        // so: this.flame_stack_so_input.join(";"),
        // func: this.flame_stack_function_input,
        // old_date: this.perfDateOptions.filter(
        //   (v) => v.name == this.old_stack_name
        // )[0].date,
        // old_version: this.perfDateOptions.filter(
        //   (v) => v.name == this.old_stack_name
        // )[0].version,

        project: this.localProject,
        level: this.level_stack,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        scene_name: this.scene_stack_id,
        size: this.flame_size_stack_input,
        so: this.flame_stack_so_input.join(";"),
        func: this.flame_stack_function_input,
        old_date: this.perfDateOptions.find((v) => v.name == this.old_stack_name).date,
        old_version: this.perfDateOptions.find((v) => v.name == this.old_stack_name).version,
        is_all: this.type,
      }

      let {data} = await grAxios({
        method: 'get',
        url: 'perfetto/perfetto_stack_v3/',
        params,
      })

      data = data.tree || {}
      this.handleStackData(data)
      this.stackTableData = [data]
    },

    formatSize(val) {
      return (val / (1024 * 1024)).toFixed(2) + 'MB'
    },

    handleStackData(obj = {}) {
      if (obj) {
        obj.rowKey = Math.random()
        obj.selfText = this.formatSize(obj.self)
        obj.totalText = this.formatSize(obj.total)
        obj.curVal = this.formatSize(obj.new)

        if (obj.children?.length) {
          obj.hasChildren = true
          obj.child = obj.children
          delete obj.children
        }
      }

      obj.child?.forEach(item => this.handleStackData(item))
    },
    
    async onSortChange({column, order}) {
      let sort_key = ''
      if (column?.label == '当前版本') {
        sort_key = 'self'
      } else if (column?.label == '变化值') {
        sort_key = this.stackType == 'tree' ? 'self_diff' : 'self'
      }

      let form = {
        level: this.level_stack,
        date: this.version_list.filter((v) => v.name == this.dateName)[0].date,
        version: this.version_list.filter((v) => v.name == this.dateName)[0]
          .version,
        type: this.type,
        scene_name: this.scene_flame_id,
        size: this.flame_size_stack_input,
        so: this.flame_stack_so_input.join(";"),
        func: this.flame_stack_function_input,
        old_date: this.version_list.filter(
          (v) => v.name == this.old_stack_name
        )[0].date,
        old_version: this.version_list.filter(
          (v) => v.name == this.old_stack_name
        )[0].version,
        sort_key,
        reverse: order == 'ascending' ? 0 : 1,
      }
      const {data} = await this.getPerfettoStackV3(form)
      this.allStackData = data
    },

    getStackRowKey(row) {
      return 'rowKey'
      //return `${row.id}-${row.count}`
    },
    handleSize(val) {
      if (!val) return 0
      else if (Math.abs(val) < 1024) {
        return val + 'B'
      } else if (Math.abs(val) < 1024 * 1024) {
        return (val / 1024).toFixed(2) + 'KB'
      } else {
        return (val / 1024 / 1024).toFixed(2) + 'MB'
      }
    },
    getCurVersion(row) {
      if (/^tree|increase$/.test(this.stackType)) {
        return this.handleSize(row.self)
      } else {
        return '--'
      }
    },
    getDiffVersion(row) {
      if (this.stackType == 'tree') {
        return this.handleSize(row.self_diff)
      } else if (this.stackType == 'decrease') {
        return this.handleSize(row.self)
      } else {
        return '--'
      }
    },
  }
}

const useStack = { //内存堆栈对比模块
  data() {
    return {
      compare_version_list: [],
      old_stack_name: "",
    }
  },

  methods: {
    async getCompareVersions() {
      // let form = {
      //   type: this.type,
      //   scene_name: this.scene_stack_id,
      //   level: this.level_stack,
      // };
      // const {data} = await  getMemoryVersion(form)
      // this.compare_version_list = data
      // this.old_stack_name = data[0]?.name
    },

    async flameStackChange(type) {
      this.getCompareVersions()

      if (type.includes("level")) {
        await this?.getMemorySceneOptions(["stack"]);
      }
      if (type.includes("scene")) {
        await this?.getMemorySoListData(["stack_memory"]);
      }
    },

    getPerfettoStackV3(data) {
      // return request({
      //   url: 'vue-admin-template/chart/pyApi/memory/perfetto_stack_v3/?level=Standard&date=2024-03-20&version=119155&type=2&scene_name=InGamePlay&size=&so=&func=&old_date=2024-03-20&old_version=119154',
      //   method: 'get',
      //   //params: data,
      //   headers: { 'Content-Type': 'applications/json' }
      // })
    }
  }
}

// 导入组件SideMenu:2
@Options({
  components: {
    Bs,
  },
  mixins: [useStackTable, useStack],
  watch: {
    perfettoStack_v2() {
      this.stackTableKey = Math.random()
      this.allStackData =  this.perfettoStack_v2 || {}
    }
  }
})
export default class TestReport extends Vue {
  //声明属性
  /* 内存堆栈对比表格 */
    // stackType = 'tree'
    // allStackData = {}
    // stackTableKey = Math.random()

    // handleStackData(obj) {
    //   if (obj) obj.rowKey = Math.random()
    //   obj.children?.forEach(item => this.handleStackData(item))
    // }
    // get stackTableData() {
    //   const data = this.allStackData?.[this.stackType] || {}
    //   this.handleStackData(data)
    //   return data ? [data] : []
    // }
    // async onSortChange({column, order}) {
    //   let sort_key = ''
    //   if (column?.label == '当前版本') {
    //     sort_key = 'self'
    //   } else if (column?.label == '变化值') {
    //     sort_key = this.stackType == 'tree' ? 'self_diff' : 'self'
    //   }

    //   const {data} = await axios('perfetto/perfetto_stack_v2/', {
    //     params: {
    //       project: this.localProject,
    //       level: this.level_stack,
    //       date: this.date,
    //       version: this.version,
    //       device_id: this.device_id,
    //       report_type: this.type_query,
    //       scene_name: this.scene_stack_id,
    //       size: this.flame_size_stack_input,
    //       so: this.flame_stack_so_input.join(";"),
    //       func: this.flame_stack_function_input,
    //       old_date: this.old_date_stack,
    //       old_version: this.old_version_stack,
    //       is_all: this.type,
    //       sort_key,
    //       reverse: order == 'ascending' ? 0 : 1,
    //     }
    //   })

    //   this.allStackData = data
    // }

    // getStackRowKey(row) {
    //   return 'rowKey'
    //   //return `${row.id}-${row.count}`
    // }
    // handleSize(val) {
    //   if (!val) return 0
    //   else if (Math.abs(val) < 1024) {
    //     return val + 'B'
    //   } else if (Math.abs(val) < 1024 * 1024) {
    //     return (val / 1024).toFixed(2) + 'KB'
    //   } else {
    //     return (val / 1024 / 1024).toFixed(2) + 'MB'
    //   }
    // }
    // getCurVersion(row) {
    //   if (/^tree|increase$/.test(this.stackType)) {
    //     return this.handleSize(row.self)
    //   } else {
    //     return '--'
    //   }
    // }
    // getDiffVersion(row) {
    //   if (this.stackType == 'tree') {
    //     return this.handleSize(row.self_diff)
    //   } else if (this.stackType == 'decrease') {
    //     return this.handleSize(row.self)
    //   } else {
    //     return '--'
    //   }
    // }
  /**/

  public downLoadNew(data, type) {
    let functionData = readGetPerfettoReport(store).risk_funcs;
    let soData = readGetPerfettoReport(store).risk_so;
    dispatchPerfettoFileName(store, {
      project: this.localProject,
      id: data.id,
    }).then((res) => {
      const link = document.createElement("a");
      dispatchPerfettoDownLoadStack(store, {
        project: this.localProject,
        id: data.id,
        old_id: data.old_id,
        func: type == "func" ? functionData[data.type][data.id].join(";") : "",
        so: type == "func" ? "" : soData[data.type][data.id].join(";"),
      }).then((htmlContent: any) => {
        // 创建一个 Blob 对象来存储 HTML 内容
        const blob = new Blob([htmlContent], { type: "text/html" });

        // 创建一个指向 Blob 对象的 URL
        const url = URL.createObjectURL(blob);

        // 创建一个临时的 <a> 标签
        const link = document.createElement("a");
        link.href = url; // 设置链接为 Blob URL
        link.download = `${res.filename}${
          type == "func" ? "_function" : "_so"
        }.html`; // 设置下载文件的名称
        link.style.display = "none"; // 隐藏 <a> 标签

        // 将 <a> 标签添加到 DOM 中
        document.body.appendChild(link);

        // 触发点击事件以开始下载
        link.click();

        // 从 DOM 中移除 <a> 标签
        document.body.removeChild(link);

        // 释放 Blob URL
        URL.revokeObjectURL(url);
      });
    });
  }
  public download(data, type, current) {
    let functionData = readGetPerfettoReport(store).risk_funcs;
    let soData = readGetPerfettoReport(store).risk_so;
    dispatchPerfettoFileName(store, {
      project: this.localProject,
      id: type ? (current == 0 ? data.base.id : data.last.id) : data.current.id,
    }).then((res) => {
      const link = document.createElement("a");
      dispatchPerfettoDownLoadStack(store, {
        project: this.localProject,
        id: data.current.id,
        old_id: type ? (current == 0 ? data.base.id : data.last.id) : "",
        func: !type
          ? ""
          : current == 0
          ? functionData.base[data.current.id]
            ? functionData.base[data.current.id].join(";")
            : ""
          : functionData.last[data.current.id]
          ? functionData.last[data.current.id].join(";")
          : "",
        so: "",
      }).then((htmlContent: any) => {
        console.log(htmlContent);
        // 创建一个 Blob 对象来存储 HTML 内容
        const blob = new Blob([htmlContent], { type: "text/html" });

        // 创建一个指向 Blob 对象的 URL
        const url = URL.createObjectURL(blob);

        // 创建一个临时的 <a> 标签
        const link = document.createElement("a");
        link.href = url; // 设置链接为 Blob URL
        link.download = `${res.filename}${type ? "_function" : ""}.html`; // 设置下载文件的名称
        link.style.display = "none"; // 隐藏 <a> 标签

        // 将 <a> 标签添加到 DOM 中
        document.body.appendChild(link);

        // 触发点击事件以开始下载
        link.click();

        // 从 DOM 中移除 <a> 标签
        document.body.removeChild(link);

        // 释放 Blob URL
        URL.revokeObjectURL(url);
      });
      if (type) {
        dispatchPerfettoDownLoadStack(store, {
          project: this.localProject,
          id: data.current.id,
          old_id: type ? (current == 0 ? data.base.id : data.last.id) : "",
          func: "",
          so: !type
            ? ""
            : current == 0
            ? soData.base[data.current.id]
              ? soData.base[data.current.id].join(";")
              : ""
            : soData.last[data.current.id]
            ? soData.last[data.current.id].join(";")
            : "",
        }).then((htmlContent: any) => {
          console.log(htmlContent);
          // 创建一个 Blob 对象来存储 HTML 内容
          const blob = new Blob([htmlContent], { type: "text/html" });

          // 创建一个指向 Blob 对象的 URL
          const url = URL.createObjectURL(blob);

          // 创建一个临时的 <a> 标签
          const link = document.createElement("a");
          link.href = url; // 设置链接为 Blob URL
          link.download = `${res.filename}_so.html`; // 设置下载文件的名称
          link.style.display = "none"; // 隐藏 <a> 标签

          // 将 <a> 标签添加到 DOM 中
          document.body.appendChild(link);

          // 触发点击事件以开始下载
          link.click();

          // 从 DOM 中移除 <a> 标签
          document.body.removeChild(link);

          // 释放 Blob URL
          URL.revokeObjectURL(url);
        });
      }
    });
    // 创建一个临时的 <a> 标签

    // link.href = value; // 链接到需要下载的文件
    // link.download = "filename.txt"; // 设置下载文件的名称
    // link.style.display = "none"; // 隐藏 <a> 标签

    // // 将 <a> 标签添加到 DOM 中
    // document.body.appendChild(link);

    // // 触发点击事件以开始下载
    // link.click();

    // // 从 DOM 中移除 <a> 标签
    // document.body.removeChild(link);
  }
  public flameShow = true;
  public async module_treand_api() {
    await dispatchPerfettoModuleTrend(store, {
      project: this.localProject,
      level: this.level,
      scene_name: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.drawModuleTrend();
    this.moudle_trend_loading = false;
  }
  public module_list = [];
  public async module_list_api() {
    await dispatchPerfettoModuleList(store, {
      project: this.localProject,
      level: this.level,
      scene_name: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.module_list = [];
    this.module_list_data.module_list.forEach((v) => {
      this.module_list.push({
        name: v,
        data: this.module_list_data.data,
      });
    });
    this.moudle_list_loading = false;
  }
  public moudle_list_loading = false;
  public backShow = false;
  public page = 1;
  public page_so = 1;
  public size = 10;
  public size_so = 10;
  public async btnAll(scene, level) {
    //  this.backShow=true

    //   this.backShow=false

    const routeUrl = this.$router.resolve({
      path: "/dmo_perfetto",
      query: {
        project: this.localProject,
        level: level,
        scene_name: scene,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
      },
    });
    window.open(routeUrl.href, "_blank");
  }
  public flameLoading = false;
  public flameLoadingStack = false;
  public flame_check_data = true;
  public async flameAllChangeSo() {
    this.flame_size_input = "";
    this.flame_so_input = [];
    this.flame_function_input = "";
    this.flameLoading = true;
    await dispatchPerfettoStack(store, {
      project: this.localProject,
      level: this.flame_so,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_flame_id,
      is_all: this.type,
    });
    if (JSON.stringify(this.perfettoStack) === "{}") {
      this.flameShow = false;
      return;
    } else {
      this.flameShow = true;
      this.flame_check_data = false;
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStack);
      });
    }

    this.flameLoading = false;
  }
  public check_view() {
    this.changeView = !this.changeView;
    this.$nextTick(() => {
      this.renderFlame_functions(
        "#chart_funcitons",
        this.perfettoStack_functions
      );
    });
  }
  // public async functions_flame_api() {
  //   await dispatchPerfettoStackSearchFuncitons(store, {
  //     project: this.localProject,
  //     level: this.level_flame,
  //     date: this.date,
  //     version: this.version,
  //     device_id: this.device_id,
  //     report_type: this.type_query,
  //     scene_name: this.scene_flame,
  //     func: this.functions_flame,
  //   });
  //   this.$nextTick(() => {
  //     this.renderFlame_functions(
  //       "#chart_funcitons",
  //       this.perfettoStack_functions
  //     );
  //   });
  // }
  // public async so_flame_api() {
  //   await dispatchPerfettoStackSearchSo(store, {
  //     project: this.localProject,
  //     level: this.so_level_flame,
  //     date: this.date,
  //     version: this.version,
  //     device_id: this.device_id,
  //     report_type: this.type_query,
  //     scene_name: this.so_scene_flame,
  //     so: this.so_flame,
  //   });
  //   this.$nextTick(() => {
  //     this.renderFlame_so("#chart_so", this.perfettoStack_so);
  //   });
  // }
  public get perfettoStack() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStack(store)));
    if (
      readGetPerfettoStack(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (!this.changeViewMemory) {
        console.log(44);
        this.traverse_update_node(obj);

        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public get perfettoStack_v2() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStackSearchV2(store)));
    if (
      readGetPerfettoStackSearchV2(store)?.tree?.children?.length == 0 ||
      JSON.stringify(obj.tree) === "{}"
    ) {
      console.log("-");
    } else {
      this.addValueField(obj?.tree);
    }
    if (
      readGetPerfettoStackSearchV2(store)?.increase?.children?.length == 0 ||
      JSON.stringify(obj.increase) === "{}"
    ) {
      console.log("-");
    } else {
      this.addValueField(obj?.increase);
    }
    if (
      readGetPerfettoStackSearchV2(store)?.decrease?.children?.length == 0 ||
      JSON.stringify(obj.decrease) === "{}"
    ) {
      console.log("-");
    } else {
      this.addValueField(obj?.decrease);
    }

    return obj;
  }
  public get perfettoStack_functions() {
    let obj = JSON.parse(
      JSON.stringify(readGetPerfettoStackSearchFunctions(store))
    );
    if (
      readGetPerfettoStackSearchFunctions(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (this.changeView) {
        this.traverse_update_node(obj);
        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public get perfettoStack_so() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStackSearchSo(store)));
    if (
      readGetPerfettoStackSearchSo(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (this.changeViewSo) {
        this.traverse_update_node(obj);
        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public get perfettoStackSearch() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStackSearch(store)));
    if (
      readGetPerfettoStackSearch(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (!this.changeViewMemory) {
        this.traverse_update_node(obj);
        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public old_record_id_created() {
    let num = 0;
    if (this.perfDateOptions.length > 1) {
      if (
        this.perfDateOptions[this.perfDateOptions.length - 1].name ==
        this.date_name
      ) {
        this.perfDateOptions.forEach((v, index) => {
          if (v.name == this.date_name) {
            num = index;
          }
        });
        this.old_date_name = this.perfDateOptions[num - 1].name;
        this.old_stack_name = this.perfDateOptions[num - 1].name;
        this.old_date_so_name = this.perfDateOptions[num - 1].name;
      } else {
        this.perfDateOptions.forEach((v, index) => {
          if (v.name == this.date_name) {
            num = index;
          }
        });
        this.old_date_name = this.perfDateOptions[num + 1].name;
        this.old_stack_name = this.perfDateOptions[num + 1].name;
        this.old_date_so_name = this.perfDateOptions[num + 1].name;
      }
      // this.perfDateOptions.forEach((v,index)=>{
      //   if(v.task_record_id==this.task_id){
      //     num=index
      //   }
      // })
      // if(num==(this.perfDateOptions.length-1)){

      // }
    } else {
      if (this.perfDateOptions.length > 0) {
        this.old_date_name = this.perfDateOptions[0].name;
        this.old_stack_name = this.perfDateOptions[0].name;
        this.old_date_so_name = this.perfDateOptions[0].name;
      }
    }
  }
  // 默认
  public loading_created() {
    if (this.perfSceneOptions.filter((v) => v.name == "Loading").length > 0) {
      return this.perfSceneOptions.filter((v) => v.name == "Loading")[0]
        .scene_id;
    } else {
      return this.perfSceneOptions.length > 0
        ? this.perfSceneOptions[0].scene_id
        : "";
    }
  }
  public get scene_flame_list() {
    let list = [];
    list = Object.keys(readGetPerfettoReport(store).func_list);
    return list;
  }
  public get scene_flame_so_list() {
    let list = [];
    list = Object.keys(readGetPerfettoReport(store).so_list);
    return list;
  }
  public get level_flame_list() {
    let list = [];
    if (this.scene_flame) {
      list = Object.keys(
        readGetPerfettoReport(store).func_list[this.scene_flame]
      );
    }

    return list;
  }
  public get level_flame_so_list() {
    let list = [];
    if (this.so_scene_flame) {
      list = Object.keys(
        readGetPerfettoReport(store).so_list[this.so_scene_flame]
      );
    }

    return list;
  }
  public get so_list() {
    let list = [];
    if (this.so_level_flame) {
      list = readGetPerfettoReport(store).so_list[this.so_scene_flame][
        this.so_level_flame
      ];
    }

    return list;
  }
  public scene_flame = "";
  public level_flame = "";
  public functions_flame = "";
  public so_scene_flame = "";
  public so_level_flame = "";
  public so_flame = [];
  public scene_natvie_id = "";
  public scene_stack_id = "";
  public scene_so_id = "";
  public scene_flame_id = "";
  public top = 20;
  public top_so = 20;
  public serch_input = "";
  public serch_input_so = "";
  public get sizeOptions() {
    let list = [10, 20, 30, "all"];

    return list;
  }
  public downloadCsv() {
    this.nativeTableAllLoading = true;
    let b = (this as any).$message({
      //Message 消息提示
      message: "导出中,请耐心等待....",
      showClose: true,
      duration: 0,
      customClass: "centered-message", // 添加自定义类名
    });

    const response_data = dispatchPerfettoNativeAllExport(store, {
      project: this.localProject,
      level: this.level_all,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_natvie_id,
      top: this.top,
      search: this.serch_input,
      old_date: this.old_date,
      old_version: this.old_version_base,
      order_by: this.order_by,
      reverse: this.reserver,
    });
    this.nativeTableAll = this.nativeAllData.slice(
      (this.page - 1) * this.size,
      this.page * this.size
    );
    response_data.then((value) => {
      // console.log(value);
      var elink = document.createElement("a");
      elink.download = "全量Native数据查看" + ".xls";
      elink.style.display = "none";
      var blob = new Blob([value], { type: "application/vnd.ms-excel" });

      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
      b.close();
      this.nativeTableAllLoading = false;
    });
  }
  public funcLoading = false;
  public async btn(scene, level) {
    let type = {
      高画质: 1,
      中画质: 2,
      低画质: 3,
    };

    const routeUrl = this.$router.resolve({
      path: "/dmo_perfetto_unreleased",
      query: {
        project: this.localProject,
        level: level,
        scene_name: scene,
        device_id: this.device_id,
        date: this.date,
        version: this.version,
        // task_record_id: this.task_id,
      },
    });
    window.open(routeUrl.href, "_blank");
  }
  public get funcTrend() {
    return readGetPerfettoNativeFuncTrend(store);
  }
  public get funcSoTrend() {
    let list = readGetPerfettoSoList(store);
    let newList = list.map((item) => {
      return item.replace(/\+/g, "");
    });

    return newList;
  }
  public get soTrend() {
    return readGetPerfettoSoFuncTrend(store);
  }
  public index_func = [];
  public index_func_so = [];
  public resBase64: any[] = [];
  public edit_show = false;
  public downloadFile() {
    if (this.perfReportPkg === "") {
      ElMessage.error("无对应的流水线");
    } else {
      window.open(this.perfReportPkg, "_blank");
    }
  }
  public isInteger = true;
  public async deleteBtn() {
    this.flame_size_input = "";
    this.flame_so_input = [];
    this.flame_function_input = "";
    this.report_loading = true;
    this.moudle_loading = true;
    this.funcLoading = true;
    this.nativeTableAllLoading = true;
    this.flameLoading = true;
    await dispatchDeletePerfetto(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
    });
    // await dispatchPerfettoOptions(store, {
    //   project: this.localProject,
    //   report_type: this.type_query,
    // });
    // if (this.perfDateOptions?.length > 0) {
    //   this.componentKey++;
    //   this.date_name = this.perfDateOptions[0].name;
    //   this.base_id = "";
    // } else {
    //   await dispatchPerfettoTypeOptions(store, {
    //     project: this.localProject,
    //   });
    //   this.type_query = this.perfTypeOptions[0].report_type;
    //   await dispatchPerfettoOptions(store, {
    //     project: this.localProject,
    //     report_type: this.type_query,
    //   });
    //   this.date_name = this.perfDateOptions[0].name;
    // }
    this.date = this.perfDateOptions.filter(
      (v) => v.name == this.date_name
    )[0].date;
    this.version = this.perfDateOptions.filter(
      (v) => v.name == this.date_name
    )[0].version;
    this.old_record_id_created();
    this.old_date = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_name
    )[0].date;
    this.old_date_stack = this.perfDateOptions.filter(
      (v) => v.name == this.old_stack_name
    )[0].date;
    this.old_so_date = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_so_name
    )[0].date;
    this.old_version_base = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_name
    )[0].version;
    this.old_version_so_base = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_so_name
    )[0].version;
    this.old_version_stack = this.perfDateOptions.filter(
      (v) => v.name == this.old_stack_name
    )[0].version;
    await dispatchPerfettoDeviceOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.device_id = this.perfDeviceOptions[0].device_id;
    await dispatchPerfettoLevelOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    await dispatchPerfettoSceneOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.scene_id = this.loading_created();
    this.scene_func_id = this.loading_created();
    this.scene_func_id_so = this.loading_created();
    this.scene_natvie_id = this.loading_created();
    this.scene_stack_id = this.loading_created();
    this.scene_so_id = this.loading_created();
    this.scene_flame_id = this.loading_created();

    await dispatchPerfettoReport(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.scene_flame =
      this.scene_flame_list?.length > 0 ? this.scene_flame_list[0] : "";
    this.level_flame =
      this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
    this.so_scene_flame =
      this.scene_flame_so_list?.length > 0 ? this.scene_flame_so_list[0] : "";
    this.so_level_flame =
      this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
    this.functions_flame = this.level_flame
      ? readGetPerfettoReport(store).func_list[this.scene_flame][
          this.level_flame
        ].join(",")
      : "";
    this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
    // this.functions_flame_api();
    // this.so_flame_api();
    this.report_loading = false;
    this.nativeHead();
    this.valueTime = [];
    await dispatchPerfettoNativeTrend(store, {
      project: this.localProject,
      level: this.level,

      report_type: Number(this.type_query),
      start: "",
      end: "",
      is_all: this.type,
    });
    this.resBase64 = [];
    this.edit_show = false;
    this.resBase64 = [];
    this.drawNativeTrend(this.device_id, this.level);

    await dispatchPerfettoNativeFuncTrend(store, {
      project: this.localProject,
      level: this.level_func,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id,
      start: "",
      end: "",
      is_all: this.type,
    });
    this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
    this.drawNativeFuncTrend();
    await dispatchPerfettoSoList(store, {
      project: this.localProject,
      level: this.level_func_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_func_id_so,
      report_type: this.type_query,
      is_all: this.type,
    });

    if (this.funcSoTrend.length > 0) {
      this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
      await dispatchPerfettoSoFuncTrend(store, {
        project: this.localProject,
        level: this.level_func_so,

        report_type: Number(this.type_query),
        scene_id: this.scene_func_id_so,
        start: "",
        end: "",
        so_list: this.index_func_so,
        is_all: this.type,
      });
      this.drawSOFuncTrend();
    }

    this.funcLoading = false;
    await dispatchPerfettoNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
      order_by: this.order_by_detail,
      reverse: this.reverse_detail,
    });

    // this.Native_thread_important();
    this.moudle_loading = false;
    this.nativeAllChange();
    this.nativeAllChangeSo();
    await dispatchPerfettoStack(store, {
      project: this.localProject,
      level: this.flame_so,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_flame_id,
      is_all: this.type,
    });
    if (JSON.stringify(this.perfettoStack) === "{}") {
      this.flameShow = false;
      return;
    } else {
      this.flameShow = true;
      this.flame_check_data = false;
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStack);
      });
    }

    this.flameLoading = false;
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
  public text(num) {
    let text = "";
    let color = "";
    if (!isNaN(num)) {
      if (num > 0) {
        text = num + "↑";
        color = "red";
      } else if (num < 0) {
        text = Math.abs(num) + "↓";
        color = "#00b050";
      } else {
        text = "0";
        color = "#606266";
      }
    } else {
      text = num;
      color = "#606266";
    }
    return [text, color];
  }
  public async settingsBtn() {
    this.report_loading = true;
    this.moudle_loading = true;
    this.configShow = false;
    // let obj: any = {
    //   perfetto_set: {
    //     name: this.base_id
    //       ? this.perfDateOptions.filter((v) => v.name == this.base_id)[0].date +
    //         " " +
    //         this.perfDateOptions.filter((v) => v.name == this.base_id)[0]
    //           .version
    //       : "",
    //   },
    // };
    this.settings.perfetto_set = {};
    this.settings.perfetto_set.name = this.base_id
      ? this.perfDateOptionsOld.filter((v) => v.name == this.base_id)[0].date +
        " " +
        this.perfDateOptionsOld.filter((v) => v.name == this.base_id)[0].version
      : "";
    let obj: any = this.settings;
    console.log(obj);
    obj = JSON.stringify(obj);

    await dispatchPerfettoSettingsEdit(store, {
      project: this.localProject,
      settings: obj,
    });
    await dispatchPerfettoReport(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: Number(this.type_query),
      is_all: this.type,
    });
    this.nativeHead();
    dispatchPerfettoNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
      order_by: this.order_by_detail,
      reverse: this.reverse_detail,
    });
    this.report_loading = false;
    this.moudle_loading = false;
  }
  public level_trend = "";
  public level_func = "";
  public level_func_so = "";
  public level_all = "";
  public level_stack = "";
  public scene_func_id_so = "";
  public level_so = "";
  public flame_so = "";
  public async trendChange() {
    // this.valueTime=[]
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]).split(" ")[0];
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]).split(" ")[0];
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }
    await dispatchPerfettoNativeTrend(store, {
      project: this.localProject,
      level: this.level_trend,

      report_type: Number(this.type_query),
      start: startTimeAll,
      end: endTimeAll,
      is_all: this.type,
    });
    this.resBase64 = [];

    this.drawNativeTrend(this.device_id, this.level);
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
  public base_id = "";
  public get settings() {
    return JSON.parse(readGetPerfettoSettings(store).settings);
  }
  public async importantChange() {
    this.page_module = 1;
    this.size_module = 10;
    this.page_native = 1;
    this.size_native = 10;
    (this.order_by_detail = "size"), (this.reverse_detail = 1);
    if (this.localProject == 7) {
      this.moudle_trend_loading = true;
      this.moudle_list_loading = true;
      this.module_treand_api();
      this.module_list_api();
    }
    await dispatchPerfettoNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
      order_by: this.order_by_detail,
      reverse: this.reverse_detail,
    });
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
    // this.Native_thread_important();
  }
  public risk(risk) {
    if (risk === "高风险") {
      return "red";
    } else if (risk == "中风险") {
      return "orange";
    } else {
      return "rgb(0, 176, 80)";
    }
  }
  public page_module = 1;
  public size_module = 10;
  public page_native = 1;
  public size_native = 10;
  public editorOption = {
    theme: "snow", // 主题
    // debug: 'info',
    placeholder: "请输入其他说明",
    modules: {
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          // ["blockquote",],
          [{ header: 1 }, { header: 2 }],

          [{ script: "sub" }, { script: "super" }],

          [{ size: ["small", false, "large", "huge"] }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }],

          ["link"],

          // ["clean", "link", "image"]
          // ['addBtn']
        ], // 自定义工具栏选项
      },
    },
  };
  public changeViewSo: any = true;
  public changeViewMemory: any = true;
  // public async edit_text() {
  //   this.edit_show = !this.edit_show;

  //   if (!this.edit_show) {
  //     dispatchPerfettoText(store, {
  //       project: this.localProject,
  //       task_record_id: Number(this.task_id),
  //       device_id: Number(this.device_id),
  //       text: this.perfReport_overview,
  //     });
  //   }
  // }
  public check_view_so() {
    this.changeViewSo = !this.changeViewSo;
    this.$nextTick(() => {
      this.renderFlame_so("#chart_so", this.perfettoStack_so);
    });
  }
  public getnum(data, item) {
    console.log(data, item);
  }
  public async save_report() {
    let b = (this as any).$message({
      //Message 消息提示
      message: "发送报告中...",
      showClose: true,
      duration: 0,
    });
    let startTimeAll = "";
    let endTimeAll = "";
    this.resBase64 = [];
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]);
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]);
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }

    for (const v of this.perfDeviceOptions) {
      await dispatchPerfettoLevelOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: v.device_id,
        report_type: this.type_query,
        is_all: this.type,
      });
      await dispatchPerfettoSceneOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: v.device_id,
        report_type: this.type_query,
        is_all: this.type,
      });
      for (let i of this.perfLeveOptions) {
        await dispatchPerfettoNativeTrend(store, {
          project: this.localProject,
          level: i.level,

          report_type: Number(this.type_query),
          start: startTimeAll,
          end: endTimeAll,
          is_all: this.type,
        });
        this.drawNativeTrend(v.device_id, i.level);
        for (let m of this.perfSceneOptions) {
          await dispatchPerfettoSoList(store, {
            project: this.localProject,
            level: i.level,
            device_id: Number(v.device_id),
            date: this.date,
            version: this.version,
            scene_id: m.scene_id,
            report_type: this.type_query,
            is_all: this.type,
          });
          if (this.funcSoTrend.length > 0) {
            let index_func_so = this.funcSoTrend.filter(
              (v, index) => index <= 9
            );
            await dispatchPerfettoSoFuncTrend(store, {
              project: this.localProject,
              level: i.level,

              report_type: Number(this.type_query),
              scene_id: m.scene_id,
              start: "",
              end: "",
              so_list: index_func_so,
              is_all: this.type,
            });
            this.drawSOFuncTrend(v.device_id, i.level, m.scene_id);
          }
        }
      }
    }
    // this.perfDeviceOptions.forEach(v=>{
    //   await dispatchPerfettoNativeTrend(store, {
    //   project: this.localProject,
    //   level: this.level,
    //   device_id: Number(this.device_id),
    //   report_type: Number(this.type_query),
    //   start:'',
    //   end:''

    // });
    // this.drawNativeTrend();
    // })
    await dispatchUploadPerfettoReport(store, {
      project: this.localProject,
      device_id: Number(this.device_id),
      scene_id: this.scene_id,
      level: Number(this.level),
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
      file_list: this.resBase64,
      report_type: this.type_query,
      url: window.location.href,
      date: this.date,
      version: this.version,
      old_date: this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].date,
      old_version: this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].version,
    });
    b.close();
    ElMessage.success({
      message: "报告发送成功",
      showClose: true,
      type: "success",
    });
    //  this.device_id=this.perfDeviceOptions[0].device_id
    await dispatchPerfettoLevelOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    await dispatchPerfettoSceneOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    // this.level = this.perfLeveOptions[0].level;
    await dispatchPerfettoNativeTrend(store, {
      project: this.localProject,
      level: this.level,

      report_type: Number(this.type_query),
      start: startTimeAll,
      end: endTimeAll,
      is_all: this.type,
    });
    await dispatchPerfettoSoList(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    if (this.funcSoTrend.length > 0) {
      this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
      await dispatchPerfettoSoFuncTrend(store, {
        project: this.localProject,
        level: this.level,

        report_type: Number(this.type_query),
        scene_id: this.scene_id,
        start: "",
        end: "",
        so_list: this.index_func_so,
        is_all: this.type,
      });
      this.drawSOFuncTrend();
    }

    this.drawNativeTrend(this.device_id, this.level);
  }
  public risk_color(num) {
    let text = "";
    let color = "";
    if (typeof num == "number") {
      if (num < 0) {
        text = Math.abs(num) + "↓";
      } else {
        text = Math.abs(num) + "↑";
        if (num >= 10 && num <= 30) {
          color = "orange";
        } else if (num < 10) {
          color = "rgb(0, 176, 80)";
        } else if (num > 30) {
          color = "red";
        }
      }
    } else {
      text = num;
    }
    return [text, color];
  }
  public sort_change_history(column) {
    this.page_module = 1;
    console.log(column);
    const orderedNames = this.sortByUnreleasedSize(
      this.module_list_data.data[column.prop],
      column.order
    );
    this.module_list = [];
    console.log(orderedNames);
    orderedNames.forEach((v) => {
      this.module_list.push({
        name: v,
        data: this.module_list_data.data,
      });
    });
  }
  public sortByUnreleasedSize(data, order) {
    // 将对象转换为数组，便于排序

    const dataArray = Object.entries(data).map(([key, value]) => ({
      name: key,
      unreleasedSize: (value as any).unreleasedSize,
    }));

    // 根据 order 参数进行排序
    if (order === "ascending") {
      dataArray.sort((a, b) => a.unreleasedSize - b.unreleasedSize);
    } else if (order === "descending") {
      dataArray.sort((a, b) => b.unreleasedSize - a.unreleasedSize);
    } else {
      // 默认按升序排序
      dataArray.sort((a, b) => a.unreleasedSize - b.unreleasedSize);
    }

    // 仅返回排序后的对象名数组
    return dataArray.map((item) => item.name);
  }

  // 祖传合并
  public mergeCells({ row, column, rowIndex, columnIndex }) {
    if (this.localProject != 7) {
      if (columnIndex === 0) {
        const rowCount = this.nativeModuleData
          ?.slice(
            (this.page_native - 1) * this.size_native,
            this.page_native * this.size_native
          )
          .filter((item) => item.parent === row.parent).length;
        if (rowCount > 1) {
          const isFirstRow =
            this.nativeModuleData
              ?.slice(
                (this.page_native - 1) * this.size_native,
                this.page_native * this.size_native
              )
              .findIndex((item) => item.parent === row.parent) === rowIndex;
          return isFirstRow
            ? { rowspan: rowCount, colspan: 1 }
            : { rowspan: 0, colspan: 0 };
        }
      }
    }

    if (this.localProject == 7 ? columnIndex === 0 : columnIndex === 1) {
      const rowCount = this.nativeModuleData
        ?.slice(
          (this.page_native - 1) * this.size_native,
          this.page_native * this.size_native
        )
        .filter((item) => item.sub === row.sub).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.nativeModuleData
            ?.slice(
              (this.page_native - 1) * this.size_native,
              this.page_native * this.size_native
            )
            .findIndex((item) => item.sub === row.sub) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mergeCells1({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.perfReport_top.filter(
        (item) => item.level === row.level
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex((item) => item.level === row.level) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = this.perfReport_top.filter(
        (item) => item.version === row.version
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex(
            (item) => item.version === row.version
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 2 || columnIndex === 4) {
      const rowCount = this.perfReport_top.filter(
        (item) => item.scene === row.scene && item.version === row.version
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex(
            (item) => item.scene === row.scene && item.version === row.version
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 3) {
      const rowCount = this.perfReport_top.filter(
        (item) =>
          item.memory_diff === row.memory_diff && item.diif_new === row.diif_new
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_top.findIndex(
            (item) =>
              item.memory_diff === row.memory_diff &&
              item.diif_new === row.diif_new
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mergeCells_so({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.perfReport_so_top.filter(
        (item) => item.level === row.level
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_so_top.findIndex(
            (item) => item.level === row.level
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 1) {
      const rowCount = this.perfReport_so_top.filter(
        (item) => item.level === row.level && item.curVersion === row.curVersion && item.lastVersion === row.lastVersion
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_so_top.findIndex(
            (item) => item.level === row.level && item.curVersion === row.curVersion && item.lastVersion === row.lastVersion
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 2 || columnIndex === 4) {
      const rowCount = this.perfReport_so_top.filter(
        (item) => item.level === row.level && item.curVersion === row.curVersion && item.lastVersion === row.lastVersion && item.scene === row.scene
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_so_top.findIndex(
            (item) => item.level === row.level && item.curVersion === row.curVersion && item.lastVersion === row.lastVersion && item.scene === row.scene
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
    if (columnIndex === 3) {
      const rowCount = this.perfReport_so_top.filter(
        (item) =>
        item.level === row.level && item.curVersion === row.curVersion && item.lastVersion === row.lastVersion && item.scene === row.scene && item.memory_diff === row.memory_diff && item.diif_new === row.diif_new
      ).length;
      if (rowCount > 1) {
        const isFirstRow =
          this.perfReport_so_top.findIndex(
            (item) =>
            item.level === row.level && item.curVersion === row.curVersion && item.lastVersion === row.lastVersion && item.scene === row.scene &&
            item.memory_diff === row.memory_diff &&
            item.diif_new === row.diif_new
          ) === rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public mergeCells2({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const rowCount = this.nativeData.filter((item) => item.name === row.name)
        .length;
      if (rowCount > 1) {
        const isFirstRow =
          this.nativeData.findIndex((item) => item.name === row.name) ===
          rowIndex;
        return isFirstRow
          ? { rowspan: rowCount, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
    }
  }
  public get native_im_data() {
    return readGetPerfettoNativeModule(store);
  }
  public contrast = true;
  public get perfDateOptions() {
    return readGetPerfettoOptions(store).date_list;
  }
  public get perfDateOptionsOld() {
    return readGetPerfeformanceOldDate(store).date_list;
  }
  public get perfTypeOptions() {
    return readGetPerfettoTypeOptions(store).options;
  }
  public version_head = [];
  public size_head = [];
  // public Native_thread_important() {
  //   let data = ["版本"];
  //   // let sizeData = ["次数"];
  //   let textList=[readGetPerfettoNativeModule(store)['cur_version'],'前后差异','基线差异']
  //   let version = ["UnreleasedSize", "UnreleasedNumber",];
  //   this.version_head = [];

  //   this.size_head = [];
  //   version.forEach(v=>{
  //     if(v=='UnreleasedSize'){
  //       textList.forEach((k,i)=>{
  //           this.version_head.push({
  //              name: (i==0?('当前版本'+k):k) + '(MB)',
  //              row:

  //       })
  //       })

  //     }
  //   })
  //   // data.forEach((v) => {
  //   //   version.forEach((k) => {
  //   //     if (k == "cur_version") {
  //   //       this.version_head.push({
  //   //         name: "当前" + v,
  //   //         value: readGetPerfettoNativeModule(store)[k],
  //   //         row: "size",
  //   //       });
  //   //     } else if (k == "base_version") {
  //   //       this.version_head.push({
  //   //         name: "基线" + v,
  //   //         value: readGetPerfettoNativeModule(store)[k],
  //   //         row: "base_size",
  //   //       });
  //   //     } else if (k == "old_version") {
  //   //       this.version_head.push({
  //   //         name: "对比" + v,
  //   //         value: readGetPerfettoNativeModule(store)[k],
  //   //         row: "old_size",
  //   //       });
  //   //     }
  //   //   });
  //   // });
  //   // sizeData.forEach((v) => {
  //   //   version.forEach((k) => {
  //   //     if (k == "cur_version") {
  //   //       this.size_head.push({
  //   //         name: "当前" + v,
  //   //         value: readGetPerfettoNativeModule(store)[k],
  //   //         row: "num",
  //   //       });
  //   //     } else if (k == "base_version") {
  //   //       this.size_head.push({
  //   //         name: "基线" + v,
  //   //         value: readGetPerfettoNativeModule(store)[k],
  //   //         row: "base_num",
  //   //       });
  //   //     } else if (k == "old_version") {
  //   //       this.size_head.push({
  //   //         name: "对比" + v,
  //   //         value: readGetPerfettoNativeModule(store)[k],
  //   //         row: "old_num",
  //   //       });
  //   //     }
  //   //   });
  //   // });
  // }
  public flame_size_input = "";
  public flame_size_stack_input = "";
  public flame_so_input = [];
  public flame_stack_so_input = [];
  public flame_function_input = "";
  public flame_stack_function_input = "";
  public edit = false;
  public sendOut() {
    this.edit = !this.edit;
  }
  public drawNativeTrend(device, level) {
    let data: any = [];

    this.nativeTrendData.scene_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.nativeTrendData.series[index],
      });
    });

    let performance_line: any = document.getElementById("native_trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "MB",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.nativeTrendData.date_list,
      },

      series: data,
    });
    var res_base64 = contrastChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    //     const regex = /- (.+?) -/;
    let match = this.perfDeviceOptions
      .filter((v) => v.device_id == device)[0]
      .name.split("-");
    // const match = this.perfDeviceOptions.filter((v) => v.device_id == device)[0].name.match(regex);
    res.file_base64 = res_base64;
    res.filename = "memory" + "-" + device + "-" + level + ".png";
    res.chinese =
      match[1] +
      "-" +
      match[2] +
      "-" +
      this.perfLeveOptions.filter((v) => v.level == level)[0].name;
    this.resBase64.push(res);
  }
  public drawModuleTrend() {
    let data: any = [];

    this.module_trend_data.module_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.module_trend_data.series[index],
      });
    });

    let performance_line: any = document.getElementById("module_trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "MB",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.module_trend_data.date_list,
      },

      series: data,
    });
  }
  public drawNativeFuncTrend() {
    let data: any = [];

    let indexes = this.funcTrend.func_list
      .filter((item, index) => {
        return this.index_func.indexOf(item) !== -1;
      })
      .map((item) => this.funcTrend.func_list.indexOf(item));

    indexes.forEach((v, index) => {
      data.push({
        name: this.funcTrend.func_list[v],
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.funcTrend.series[v],
      });
    });

    let performance_line: any = document.getElementById("native_func_trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "MB",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.funcTrend.date_list,
      },

      series: data,
    });
    // var res_base64 = contrastChart.getDataURL({
    //   excludeComponents: ["toolbox"],
    // }); //拿到base64 地址，就好下载了。
    // let res: any = {};
    // res.file_base64 = res_base64;
    // res.filename = 'func_trend.png';
    // res.chinese ='画质:'+ this.perfLeveOptions.filter(
    //   (v) => v.level == this.level_func
    // )[0].name;
    // this.resBase64.push(res);
  }
  public async flame_btn() {
    this.flameLoading = true;
    this.isInteger = Number.isInteger(Number(this.flame_size_input));
    if (this.isInteger == false) {
      ElMessage.error("size请输入整数");
      this.flameLoading = false;
      return;
    }
    await dispatchPerfettoStackSearch(store, {
      project: this.localProject,
      level: this.flame_so,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_flame_id,
      size: this.flame_size_input,
      so: this.flame_so_input.join(";"),
      func: this.flame_function_input,
    });
    if (JSON.stringify(this.perfettoStackSearch) === "{}") {
      this.flameShow = false;
      ElMessage.error("未查询到数据");
    } else {
      this.flameShow = true;
      this.flame_check_data = true;
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStackSearch);
      });
    }
    this.flameLoading = false;
  }
  public async flame_btn_stack() {
    this.flameLoadingStack = true;
    this.isInteger = Number.isInteger(Number(this.flame_size_input));
    if (this.isInteger == false) {
      ElMessage.error("size请输入整数");
      this.flameLoadingStack = false;
      return;
    }

    //this.stack_v2_api()
    (this as any).getStackTableData()
  }
  public drawSOFuncTrend(device?, level?, scene?) {
    let data: any = [];

    // console.log(indexes)
    this.soTrend.so_list.forEach((v, index) => {
      data.push({
        name: v,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: this.soTrend.series[index],
      });
    });

    let performance_line: any = document.getElementById("so_func_trend");
    echarts.dispose(performance_line);
    var contrastChart = echarts.init(performance_line);
    contrastChart.setOption({
      tooltip: {
        trigger: "axis",
      },

      legend: {
        type: "scroll",
        x: "center",
        y: "bottom",
        padding: [0, 0, 10, 0],
        // data: devices.map(
        //   (item) =>
        //     this.getDeviceSpecs.filter(
        //       (device) => device.id === item.device_id
        //     )[0]?.model.name
        // ),
      },
      yAxis: {
        type: "value",
        name: "MB",
        //  nameLocation: "top",
        // 坐标轴名称与轴线之间的距离。
        // nameGap: 35,
        // nameRotate: 90,
        axisTick: false,
        //左侧线
        // axisLine: {
        //   show: true,
        // },
        //  splitLine: {
        //   show: true,
        // },
      },
      grid: {
        left: "4%",
        top: "10%",
        bottom: "10%",
        right: "4%",
        containLabel: true,
      },
      animation: false,
      xAxis: {
        type: "category",
        data: this.soTrend.date_list,
      },

      series: data,
    });
    if (device && level) {
      var res_base64 = contrastChart.getDataURL({
        excludeComponents: ["toolbox"],
      }); //拿到base64 地址，就好下载了。
      let res: any = {};
      //     const regex = /- (.+?) -/;
      let match = this.perfDeviceOptions
        .filter((v) => v.device_id == device)[0]
        .name.split("-");
      // const match = this.perfDeviceOptions.filter((v) => v.device_id == device)[0].name.match(regex);
      res.file_base64 = res_base64;
      res.filename =
        "so_trend" + "-" + device + "-" + level + "-" + scene + ".png";
      res.chinese =
        scene +
        "-" +
        this.perfLeveOptions.filter((v) => v.level == level)[0].name;
      this.resBase64.push(res);
    }
  }
  public funcChange() {
    this.drawNativeFuncTrend();
  }

  public get old_version() {
    let string = "";
    string = readGetPerfettoNativeAll(store).old_version;
    return string;
  }
  public async funcChange_so() {
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]);
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]);
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }
    await dispatchPerfettoSoFuncTrend(store, {
      project: this.localProject,
      level: this.level_func_so,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id_so,
      start: startTimeAll,
      end: endTimeAll,
      so_list: this.index_func_so,
      is_all: this.type,
    });
    this.drawSOFuncTrend();
  }
  public async funcChange_api_so() {
    let startTimeAll = "";
    let endTimeAll = "";
    this.soLoading = true;
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]);
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]);
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }
    await dispatchPerfettoSoList(store, {
      project: this.localProject,
      level: this.level_func_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_func_id_so,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
    await dispatchPerfettoSoFuncTrend(store, {
      project: this.localProject,
      level: this.level_func_so,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id_so,
      start: startTimeAll,
      end: endTimeAll,
      so_list: this.index_func_so,
      is_all: this.type,
    });
    this.drawSOFuncTrend();
    this.soLoading = false;
  }
  public check_view_memory() {
    this.changeViewMemory = !this.changeViewMemory;
    this.$nextTick(() => {
      if (this.flame_check_data == false) {
        this.renderFlame("#chart", this.perfettoStack);
      } else {
        this.$nextTick(() => {
          this.renderFlame("#chart", this.perfettoStackSearch);
        });
      }
    });
  }
  public async funcChange_api() {
    this.funcLoading = true;
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]).split(" ")[0];
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]).split(" ")[0];
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }
    await dispatchPerfettoNativeFuncTrend(store, {
      project: this.localProject,
      level: this.level_func,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id,
      start: startTimeAll,
      end: endTimeAll,
      is_all: this.type,
    });
    this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
    this.drawNativeFuncTrend();
    this.funcLoading = false;
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
  public get perfDeviceOptions() {
    return readGetPerfettoDeviceOptions(store).device_list;
  }
  public get perfDeviceOptionsTrend() {
    return readGetPerfettoDeviceOptionsTrend(store).device_list;
  }
  public get perfDeviceOptionsImportant() {
    return readGetPerfettoDeviceOptionsImportant(store).device_list;
  }
  public get perfReport() {
    return readGetPerfettoReport(store).native;
  }
  public get perfReportPkg() {
    return readGetPerfettoReport(store).pipeline_download_url;
  }
  public get perfReport_overview() {
    let list = [
      { scene: "LaunchGame", text: "游戏启动到大厅的部分" },
      { scene: "LobbyRooms", text: "游戏大厅、游戏房间，进入加载阶段" },
      { scene: "InGamePlay", text: "游戏对局内/休闲区场景内" },
    ];

    if (this.localProject === 34) {
      list = [
        { scene: "Loading", text: "从开始启动游戏到进入大厅静置10s稳定下来" },
        {
          scene: "SelectHero",
          text: "从开始启动游戏到刚开始进入Battle战斗场景之前",
        },
        { scene: "Battle5v5", text: "从开始启动游戏到结束战斗前5s" },
        {
          scene: "LobbyWait",
          text: "从开始启动游戏到结束战斗后再返回大厅静置5min",
        },
      ];
    } else if ([13, 15, 16].includes(this.localProject)) {
      list = [
        {scene: "BrPerfetto", text: "BR黑色战域"},
        {scene: "MultiPerfetto", text: "MP穿越火线"}
      ]
    }
    return list;
  }
  public get perfReport_file_list() {
    return readGetPerfettoReport(store).file_list;
  }
  public soLoading = false;
  public get perfReport_top() {
    let data = readGetPerfettoReport(store).top_table;
    let list = [];
    data?.forEach((v) => {
      v.functions.forEach((m) => {
        list.push({
          level: v.level,
          scene: v.scene_name,
          id: v.id,
          old_id: v.old_id,
          curVersion: v.cur_version,
          lastVersion: v.last_version,
          diif_new: v.cur,
          memory_diff: v.diff,
          funcName: m.func_name,
          diff: m.diff,
          type: v.type,
        });
      });
    });
    const sortedData = list.sort((a, b) => {
      if (a.level < b.level) {
        return -1;
      } else if (a.level > b.level) {
        return 1;
      } else {
        return 0;
      }
    });

    return sortedData;
  }
  public get perfReport_so_top() {
    let data = readGetPerfettoReport(store).top_so_table;
    let list = [];
    data?.forEach((v) => {
      v.functions.forEach((m) => {
        list.push({
          level: v.level,
          scene: v.scene_name,
          id: v.id,
          old_id: v.old_id,
          curVersion: v.cur_version,
          lastVersion: v.last_version,
          diif_new: v.cur,
          memory_diff: v.diff,
          funcName: m.func_name,
          diff: m.diff,
          type: v.type,
        });
      });
    });
    const sortedData = list.sort((a, b) => {
      if (a.level < b.level) {
        return -1;
      } else if (a.level > b.level) {
        return 1;
      } else {
        return 0;
      }
    });

    console.log('sortedData', sortedData)
    return sortedData;
  }
  public get perfLeveOptions() {
    return readGetPerfettoLevelOptions(store).options;
  }
  public get perfLeveOptionsImportant() {
    return readGetPerfettoLevelOptionsImportant(store).options;
  }
  public get perfSceneOptions() {
    return readGetPerfettoSceneOptions(store).options;
  }
  public async timeChange() {
    let startTimeAll = "";
    let endTimeAll = "";
    if (this.valueTime) {
      startTimeAll =
        dateConversion(this.valueTime[0]) == "-"
          ? ""
          : dateConversion(this.valueTime[0]).split(" ")[0];
      endTimeAll =
        dateConversion(this.valueTime[1]) == "-"
          ? ""
          : dateConversion(this.valueTime[1]).split(" ")[0];
    } else {
      startTimeAll = "";
      endTimeAll = "";
    }

    await dispatchPerfettoNativeTrend(store, {
      project: this.localProject,
      level: this.level,

      report_type: Number(this.type_query),
      start: startTimeAll,
      end: endTimeAll,
      is_all: this.type,
    });
    await dispatchPerfettoNativeFuncTrend(store, {
      project: this.localProject,
      level: this.level_func,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id,
      start: startTimeAll,
      end: endTimeAll,
      is_all: this.type,
    });
    this.resBase64 = [];
    this.drawNativeTrend(this.device_id, this.level);
    this.drawNativeFuncTrend();
  }

  public get nativeData() {
    let list = [];
    for (let i in this.perfReport) {
      for (let k in this.perfReport[i]) {
        list.push({ name: i, picture: k, data: this.perfReport[i][k] });
      }
    }

    return list;
  }
  public get nativeTrendData() {
    return readGetPerfettoNativeTrend(store);
  }
  public screen(item) {
    if (item == "func") {
      const { href } = this.$router.resolve({
        path: "/full_screen_display",
        query: {
          ...this.$route.query,
          type: item,
          check: this.changeView,
          level: this.level_flame,
          date: this.date,
          version: this.version,
          device_id: this.device_id,
          report_type: this.type_query,
          scene_name: this.scene_flame,
          func: this.functions_flame,
        },
      });
      window.open(href, "_blank");
    }
    if (item == "so") {
      const { href } = this.$router.resolve({
        path: "/full_screen_display",
        query: {
          ...this.$route.query,
          type: item,
          check: this.changeViewSo,
          level: this.so_level_flame,
          date: this.date,
          version: this.version,
          device_id: this.device_id,
          report_type: this.type_query,
          scene_name: this.so_scene_flame,
          so: this.so_flame.length > 0 ? this.so_flame : "",
          is_all: this.type,
        },
      });
      window.open(href, "_blank");
    }
    if (item == "memory") {
      const { href } = this.$router.resolve({
        path: "/full_screen_display",
        query: {
          ...this.$route.query,
          type: item,
          check: this.changeViewMemory,
          level: this.flame_so,
          date: this.date,
          version: this.version,
          device_id: this.device_id,
          report_type: this.type_query,
          scene_name: this.scene_flame_id,
          size: this.flame_size_input,
          so: this.flame_so_input.length > 0 ? this.flame_so_input : "",
          func: this.flame_function_input,
          is_all: this.type,
        },
      });
      window.open(href, "_blank");
    }
    if (item == "merge") {
      const { href } = this.$router.resolve({
        path: "/full_screen_display",
        query: {
          ...this.$route.query,
          type: item,
          check: this.changeViewMemory,
          level: this.level_stack,
          date: this.date,
          version: this.version,
          device_id: this.device_id,
          report_type: this.type_query,
          scene_name: this.scene_stack_id,
          size: this.flame_size_stack_input,
          so:
            this.flame_stack_so_input.length > 0
              ? this.flame_stack_so_input
              : "",
          func: this.flame_stack_function_input,
          old_date_name: this.old_date_name,
          old_date_stack: this.old_date_stack,
          old_version_stack: this.old_version_stack,
          is_all: this.type,
        },
      });
      window.open(href, "_blank");
    }
  }
  public get nativeModuleData() {
    let data = readGetPerfettoNativeModule(store).module;
    let list = [];
    for (let i in data) {
      for (let k in data[i].sub_module) {
        for (let c in data[i].sub_module[k].functions) {
          list.push({
            parent: i,
            sub: k,
            func: c,
            data: data[i].sub_module[k].functions[c],
          });
        }
      }
    }

    return list;
  }
  // public task_id = "";
  public date_name = "";
  public type_query: any = "";

  public device_id = "";
  public configShow = false;
  public date: any = "";
  public version: any = "";
  public level = "";

  public nativeVersionList = [];
  public scene_id = "";
  public scene_func_id = "";

  public changeList = [];
  public nativeHead() {
    let list = ["current"];
    let list1 = ["当前版本"];
    let change = ["基线变化值", "前后变化值"];
    let target = ["unreleaseMallocSize", "totalMallocSize"];
    this.nativeVersionList = [];
    this.changeList = [];
    // console.log(this.nativeData)
    list.forEach((v, index) => {
      this.nativeVersionList.push({
        head: list1[index],
        label: v,
        target: target,
        value: this.nativeData[0].data[v].version,
      });
    });
    change.forEach((v) => {
      this.changeList.push({
        head: v,
        i: ["unreleaseMallocSize", "totalMallocSize"],
        color:
          v == "基线变化值"
            ? ["base_released_color", "base_total_color"]
            : ["last_released_color", "last_total_color"],
        target:
          v == "基线变化值"
            ? ["ReleaseBaseDiff", "TotalBaseDiff"]
            : ["ReleaseLastDiff", "TotalLastDiff"],
        value:
          v == "基线变化值"
            ? this.nativeData[0].data.base.version
            : this.nativeData[0].data.last.version,
      });
    });
  }
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "K";
      }
      if (Number(item) > 1024) {
        return (Number(item) / 1024).toFixed(1) + "M";
      }
    } else {
      return "";
    }
  }
  public localProject = Number(getLocalProject()); //得到本地的项目
  public get report_data() {
    let list = [];
    let falseArray: any = [36, 34, 40, 47, 12, 32, 4];
    if (
      this.localProject === 40 ||
      this.localProject === 32 ||
      this.localProject === 47
    ) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
      ];
    } else if (this.localProject == 34) {
      list = [
        { name: "Default", value: 0 },
        { name: "局内皮肤测试  ", value: 4 },
        { name: "局外皮肤测试", value: 3 },
        { name: "5V5真人测试", value: 9 },
        { name: "极限测试", value: 8 },
        { name: "皮肤异常测试", value: 13 },
        { name: "内存测试-10真人", value: 34 },
        { name: "内存测试-1真人", value: 35 },
      ];
    }
    if (this.localProject === 32) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤异常测试", value: 13 },
      ];
    }
    if (this.localProject === 36) {
      list = [
        { name: "Default", value: 0 },
        { name: "皮肤测试报告", value: 5 },
        { name: "UI性能测试报告", value: 25 },
      ];
    }
    if (this.localProject === 4) {
      list = [
        { name: "Default", value: 0 },
        { name: "分支性能", value: 21 },
        { name: "主干性能", value: 22 },
        { name: "分支dev", value: 23 },
        { name: "主干dev", value: 24 },
        { name: "登录测试", value: 30 },
        { name: "iOS登录", value: 41 },
      ];
    }
    if (this.localProject === 12) {
      list = [{ name: "Default", value: 0 }];
    } else if (falseArray.every((v) => v != this.localProject)) {
      list = [{ name: "Default", value: 0 }];
    }

    return list;
  }
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public valueTime = [];
  public componentKey = 0;

  public async memoryChange(item) {
    if (item.includes("is_all")) {
      await dispatchPerfettoTypeOptions(store, {
        project: this.localProject,
        is_all: this.type,
      });
      this.type_query =
        this.perfTypeOptions.length > 0
          ? this.perfTypeOptions[0].report_type
          : "";
    }
    if (item.includes("report_type")) {
      await dispatchPerfettoOptions(store, {
        project: this.localProject,
        report_type: this.type_query,
        is_all: this.type,
      });
      this.componentKey++;
      this.date_name =
        this.perfDateOptions.length > 0 ? this.perfDateOptions[0].name : "";
      this.date =
        this.perfDateOptions.length > 0 ? this.perfDateOptions[0].date : "";
      this.version =
        this.perfDateOptions.length > 0 ? this.perfDateOptions[0].version : "";
      this.old_record_id_created();
      if (this.perfDateOptions.length > 0) {
        this.old_date = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_name
        )[0].date;
        this.old_date_stack = this.perfDateOptions.filter(
          (v) => v.name == this.old_stack_name
        )[0].date;
        this.old_version_base = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_name
        )[0].version;
        this.old_so_date = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_so_name
        )[0].date;
        this.old_date_base_name = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_so_name
        )[0].version;
        this.old_version_stack = this.perfDateOptions.filter(
          (v) => v.name == this.old_stack_name
        )[0].version;
      }

      this.base_id = "";

      // this.type_query = this.perfDateOptions.filter(
      //   (v) => v.task_record_id == this.task_id
      // )[0].report_type;
    }
    if (item.includes("task_id")) {
      if (this.perfDateOptions.length > 0) {
        this.date = this.perfDateOptions.filter(
          (v) => v.name == this.date_name
        )[0].date;
        this.version = this.perfDateOptions.filter(
          (v) => v.name == this.date_name
        )[0].version;
        this.old_record_id_created();
        this.old_date = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_name
        )[0].date;
        this.old_date_stack = this.perfDateOptions.filter(
          (v) => v.name == this.old_stack_name
        )[0].date;
        this.old_version_base = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_name
        )[0].version;
        this.old_so_date = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_so_name
        )[0].date;
        this.old_version_so_base = this.perfDateOptions.filter(
          (v) => v.name == this.old_date_so_name
        )[0].version;
        this.old_version_stack = this.perfDateOptions.filter(
          (v) => v.name == this.old_stack_name
        )[0].version;
      }

      await dispatchPerfettoDeviceOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        report_type: this.type_query,
        is_all: this.type,
      });

      const defaultOption = this.perfDeviceOptions.find(item => item.name.includes('J200')) || this.perfDeviceOptions[0]
      this.device_id = defaultOption?.device_id

      // this.type_query = this.perfDateOptions.filter(
      //   (v) => v.task_record_id == this.task_id
      // )[0].report_type;
    }
    if (item.includes("device_id")) {
      this.base_id = "";
      await dispatchPerfettoOldOptions(store, {
        project: this.localProject,
        report_type: this.type_query,
        is_all: this.type,
        device_id: this.device_id,
      });

      await dispatchPerfettoLevelOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        is_all: this.type,
      });

      this.level =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_trend =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_func =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_func_so =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_all =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_stack =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.level_so =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      this.flame_so =
        this.perfLeveOptions.length > 0 ? this.perfLeveOptions[0].level : "";
      await dispatchPerfettoSceneOptions(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.type_query,
        is_all: this.type,
      });
      this.scene_id = this.loading_created();
      this.scene_func_id = this.loading_created();
      this.scene_func_id_so = this.loading_created();
      this.scene_natvie_id = this.loading_created();
      this.scene_stack_id = this.loading_created();
      this.scene_so_id = this.loading_created();
      this.scene_flame_id = this.loading_created();
    }
  }
  public newCount: any = null;
  public reserver: any = 1;
  public order_by = "";
  public order_by_detail = "size";
  public reserver_so: any = 1;
  public reverse_detail: any = 1;
  public order_by_so = "";
  public typeList = [
    { name: "增量", value: "0" },
    { name: "全量", value: "1" },
  ];
  public type: any = "";
  public async sort_change(column) {
    this.page = 1;

    this.nativeTableAllLoading = true;
    this.reserver = column.order ? (column?.order == "ascending" ? 0 : 1) : "";
    this.order_by = column.prop ? column.prop : "";
    await dispatchPerfettoNativeAll(store, {
      project: this.localProject,
      level: this.level_all,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_natvie_id,
      top: this.top,
      search: this.serch_input,
      old_date: this.old_date,
      old_version: this.old_version_base,
      order_by: this.order_by,
      reverse: this.reserver,
      is_all: this.type,
    });
    this.nativeTableAll = this.nativeAllData.slice(
      (this.page - 1) * this.size,
      this.page * this.size
    );
    this.nativeTableAllLoading = false;
  }
  public async sort_change_detail(column) {
    this.page_native = 1;
    this.size_native = 10;
    this.moudle_loading = true;
    this.reverse_detail = column.order
      ? column?.order == "ascending"
        ? 0
        : 1
      : "";
    this.order_by_detail = column.prop ? column.prop : "";
    await dispatchPerfettoNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
      order_by: this.order_by_detail,
      reverse: this.reverse_detail,
    });

    // this.Native_thread_important();
    this.moudle_loading = false;
  }
  public async sort_change_so(column) {
    this.page_so = 1;

    this.nativeTableAllLoading = true;
    this.reserver_so = column.order
      ? column?.order == "ascending"
        ? 0
        : 1
      : "";
    this.order_by_so = column.prop ? column.prop : "";
    await dispatchPerfettoSoAll(store, {
      project: this.localProject,
      level: this.level_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_so_id,
      top: this.top_so,
      search: this.serch_input_so,
      old_date: this.old_so_date,
      old_version: this.old_version_so_base,
      order_by: this.order_by_so,
      reverse: this.reserver_so,
      is_all: this.type,
    });
    this.nativeTableSoAll = this.nativeAllSoData.slice(
      (this.page_so - 1) * this.size_so,
      this.page_so * this.size_so
    );
    this.nativeTableAllLoading = false;
  }
  public sortFun(attr, rev) {
    if (rev == "-") {
      rev = 1;
    } else {
      rev = rev ? 1 : -1;
    }
    return (a, b) => {
      a = a[attr];
      b = b[attr];

      return this.customSort(a, b, rev);
    };
  }
  public customSort(a, b, rev) {
    if (a === undefined || a === "-") {
      return 1;
    } else if (b === undefined || b === "-") {
      return -1;
    } else {
      return (a - b) * rev;
    }
  }
  public flame_function_change(flag) {
    if (flag) {
      this.level_flame =
        this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
    }

    this.functions_flame = this.level_flame
      ? readGetPerfettoReport(store).func_list[this.scene_flame][
          this.level_flame
        ].join(",")
      : "";
  }
  public flame_so_change(flag) {
    if (flag) {
      this.so_level_flame =
        this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
    }

    this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
  }
  // public flame_function_btn() {
  //   this.functions_flame_api();
  // }
  // public flame_so_btn() {
  //   this.so_flame_api();
  // }

  public async memoryBtn() {
    this.page_module = 1;
    this.size_module = 10;
    this.page_native = 1;
    this.size_native = 10;
    this.flame_size_input = "";
    this.flame_so_input = [];
    this.moudle_trend_loading = true;
    this.moudle_list_loading = true;
    this.flame_function_input = "";
    this.flame_size_stack_input = "";
    this.flame_stack_so_input = [];
    this.flame_stack_function_input = "";
    this.report_loading = true;
    this.moudle_loading = true;
    this.funcLoading = true;
    this.flameLoading = true;
    this.flameLoadingStack = true;
    this.nativeTableAllLoading = true;
    await dispatchPerfettoReport(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });
    this.scene_flame =
      this.scene_flame_list?.length > 0 ? this.scene_flame_list[0] : "";
    this.level_flame =
      this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
    this.so_scene_flame =
      this.scene_flame_so_list?.length > 0 ? this.scene_flame_so_list[0] : "";
    this.so_level_flame =
      this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
    this.functions_flame = this.level_flame
      ? readGetPerfettoReport(store).func_list[this.scene_flame][
          this.level_flame
        ].join(",")
      : "";
    this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
    // this.functions_flame_api();
    // this.so_flame_api();
    this.report_loading = false;
    this.nativeHead();
    this.valueTime = [];
    if (this.localProject === 7) {
      //this.stack_v2_api()
      (this as any)?.getStackTableData()
      this.module_treand_api();
      this.module_list_api();
    }
    await dispatchPerfettoNativeTrend(store, {
      project: this.localProject,
      level: this.level,

      report_type: Number(this.type_query),
      start: "",
      end: "",
      is_all: this.type,
    });
    this.resBase64 = [];
    this.edit_show = false;
    this.resBase64 = [];

    this.drawNativeTrend(this.device_id, this.level);
    await dispatchPerfettoNativeFuncTrend(store, {
      project: this.localProject,
      level: this.level_func,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id,
      start: "",
      end: "",
      is_all: this.type,
    });
    this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
    this.drawNativeFuncTrend();
    await dispatchPerfettoSoList(store, {
      project: this.localProject,
      level: this.level_func_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_func_id_so,
      report_type: this.type_query,
      is_all: this.type,
    });
    if (this.funcSoTrend.length > 0) {
      this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
      await dispatchPerfettoSoFuncTrend(store, {
        project: this.localProject,
        level: this.level_func_so,

        report_type: Number(this.type_query),
        scene_id: this.scene_func_id_so,
        start: "",
        end: "",
        so_list: this.index_func_so,
        is_all: this.type,
      });
      this.drawSOFuncTrend();
    }

    this.funcLoading = false;
    await dispatchPerfettoNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
      order_by: this.order_by_detail,
      reverse: this.reverse_detail,
    });

    // this.Native_thread_important();
    this.moudle_loading = false;
    this.nativeAllChange();
    this.nativeAllChangeSo();
    await dispatchPerfettoStack(store, {
      project: this.localProject,
      level: this.flame_so,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_flame_id,
      is_all: this.type,
    });
    if (JSON.stringify(this.perfettoStack) === "{}") {
      this.flameShow = false;
      return;
    } else {
      this.flameShow = true;
      this.flame_check_data = false;
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStack);
      });
    }
    this.flameLoading = false;
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
  public nativeTableAllLoading = false;
  public async nativeAllChange() {
    this.nativeTableAllLoading = true;
    this.page = 1;
    this.size = 10;
    this.top = 20;
    this.serch_input = "";
    this.old_date = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_name
    )[0].date;
    this.old_version_base = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_name
    )[0].version;
    await dispatchPerfettoNativeAll(store, {
      project: this.localProject,
      level: this.level_all,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_natvie_id,
      top: this.top,
      search: this.serch_input,
      old_date: this.old_date,
      old_version: this.old_version_base,
      order_by: this.order_by,
      reverse: this.reserver,
      is_all: this.type,
    });
    this.nativeTableAll = this.nativeAllData.slice(
      (this.page - 1) * this.size,
      this.page * this.size
    );
    this.nativeTableAllLoading = false;
    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
  public merge_show = true;
  public async stack_v2_api() {
    this.old_date_stack = this.perfDateOptions.filter(
      (v) => v.name == this.old_stack_name
    )[0].date;
    this.old_version_stack = this.perfDateOptions.filter(
      (v) => v.name == this.old_stack_name
    )[0].version;
    await dispatchPerfettoStackSearchV2(store, {
      project: this.localProject,
      level: this.level_stack,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_stack_id,
      size: this.flame_size_stack_input,
      so: this.flame_stack_so_input.join(";"),
      func: this.flame_stack_function_input,
      old_date: this.old_date_stack,
      old_version: this.old_version_stack,
      is_all: this.type,
    });
    if (JSON.stringify(this.perfettoStack_v2?.tree) !== "{}") {
      this.stack_show = false;
      this.$nextTick(() => {
        this.renderFlame_v2("#tree", this.perfettoStack_v2.tree);
      });
    } else {
      this.stack_show = true;
    }
    if (JSON.stringify(this.perfettoStack_v2?.decrease) !== "{}") {
      this.delete_show = false;
      this.$nextTick(() => {
        this.renderFlame_v2("#decrease", this.perfettoStack_v2?.decrease);
      });
    } else {
      this.delete_show = true;
    }
    if (JSON.stringify(this.perfettoStack_v2?.increase) !== "{}") {
      this.add_show = false;
      this.$nextTick(() => {
        this.renderFlame_v2("#increase", this.perfettoStack_v2?.increase);
      });
    } else {
      this.add_show = true;
    }
    let merge_stack = {
      children: [
        this.perfettoStack_v2?.increase,
        this.perfettoStack_v2?.tree,
        this.perfettoStack_v2?.decrease,
      ],
      functionName: "root",
      soName: "root",
      sourceFileName: "root",
      total:
        this.perfettoStack_v2?.increase.total +
        this.perfettoStack_v2?.decrease.total +
        this.perfettoStack_v2.tree.total,
      self:
        this.perfettoStack_v2?.increase.self +
        this.perfettoStack_v2?.decrease.self +
        this.perfettoStack_v2.tree.self,
      type: "merge",
    };
    this.addValueField(merge_stack);

    if (
      JSON.stringify(this.perfettoStack_v2?.increase) == "{}" &&
      JSON.stringify(this.perfettoStack_v2?.decrease) === "{}" &&
      JSON.stringify(this.perfettoStack_v2?.tree) === "{}"
    ) {
      this.merge_show = false;
    } else {
      this.merge_show = true;
    }
    this.$nextTick(() => {
      if (this.merge_show) {
        this.renderFlame_v2_merge("#merge", merge_stack);
      }
    });
    this.flameLoadingStack = false;
  }
  public stack_show = false;
  public add_show = false;
  public delete_show = false;
  public async nativeAllChangeSo() {
    this.nativeTableAllLoading = true;
    this.page_so = 1;
    this.size_so = 10;
    this.top_so = 20;
    this.serch_input_so = "";
    this.old_so_date = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_so_name
    )[0].date;
    this.old_version_so_base = this.perfDateOptions.filter(
      (v) => v.name == this.old_date_so_name
    )[0].version;
    await dispatchPerfettoSoAll(store, {
      project: this.localProject,
      level: this.level_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_so_id,
      top: this.top_so,
      search: this.serch_input_so,
      old_date: this.old_so_date,
      old_version: this.old_version_so_base,
      order_by: "unreleasedSizeDiff",
      reverse: 1,
      is_all: this.type,
    });
    this.nativeTableSoAll = this.nativeAllSoData.slice(
      (this.page_so - 1) * this.size_so,
      this.page_so * this.size_so
    );
    this.nativeTableAllLoading = false;
    // this.$router.push({
    //   query: {
    //     ...this.$route.query,
    //     date: this.date,
    //     version: this.version,
    //     old_date: this.old_date,
    //     old_version_base: this.old_version_base,
    //     device_id: this.device_id,
    //     type: this.type_query,
    //     level: this.level,
    //     level_trend: this.level_trend,
    //     level_func: this.level_func,
    //     level_all: this.level_all,
    //     scene_id: this.scene_id,
    //     scene_func_id: this.scene_func_id,
    //     scene_natvie_id: this.scene_natvie_id,
    //     // old_record_id: this.old_record_id,
    //   },
    // });
  }
  public async onSearch(item) {
    this.nativeTableAllLoading = true;
    if (item) {
      this.page = 1;
      this.size = 10;
      await dispatchPerfettoNativeAll(store, {
        project: this.localProject,
        level: this.level_all,
        device_id: Number(this.device_id),
        date: this.date,
        version: this.version,
        scene_id: this.scene_natvie_id,
        top: this.top,
        search: this.serch_input,
        old_date: this.old_date,
        old_version: this.old_version_base,
        order_by: this.order_by,
        reverse: this.reserver,
        is_all: this.type,
      });
    }

    this.nativeTableAll = this.nativeAllData.slice(
      (this.page - 1) * this.size,
      this.page * this.size
    );
    this.nativeTableAllLoading = false;
  }
  public async onSearchSo(item) {
    this.nativeTableAllLoading = true;

    if (item) {
      this.page_so = 1;
      this.size_so = 10;
      await dispatchPerfettoSoAll(store, {
        project: this.localProject,
        level: this.level_so,
        device_id: Number(this.device_id),
        date: this.date,
        version: this.version,
        scene_id: this.scene_so_id,
        top: this.top_so,
        search: this.serch_input_so,
        old_date: this.old_so_date,
        old_version: this.old_version_so_base,
        order_by: this.order_by_so,
        reverse: this.reserver_so,
        is_all: this.type,
      });
    }

    this.nativeTableSoAll = this.nativeAllSoData.slice(
      (this.page_so - 1) * this.size_so,
      this.page_so * this.size_so
    );
    this.nativeTableAllLoading = false;
  }
  public report_loading = false;
  public moudle_loading = false;
  public get nativeAllData() {
    return readGetPerfettoNativeAll(store).list;
  }
  public get nativeAllSoData() {
    return readGetPerfettoSoAll(store).list;
  }
  public nativeAllHead = [
    {
      new: "mallocNumber",
      old: "mallocNumberDiff",
      label: "TotalNativeMallocCount",
    },
    {
      new: "mallocSize",
      old: "mallocSizeDiff",
      label: "TotalNativeMallocSize",
    },

    {
      new: "unreleasedNumber",
      old: "unreleasedNumberDiff",
      label: "UnreleasedNativeMallocCount",
    },
    {
      new: "unreleasedSize",
      old: "unreleasedSizeDiff",
      label: "UnreleasedNativeMallocSize",
    },
  ];
  public nativeAllHead1 = [
    {
      new: "mallocNumber",
      old: "mallocNumberDiff",
      label: "TotalNativeMallocCount",
    },
    {
      new: "mallocSize",
      old: "mallocSizeDiff",
      label: "TotalNativeMallocSize",
    },

    {
      new: "unreleasedNumber",
      old: "unreleasedNumberDiff",
      label: "UnreleasedNativeMallocCount",
    },
    {
      new: "unreleasedSize",
      old: "unreleasedSizeDiff",
      label: "UnreleasedNativeMallocSize",
    },
  ];
  public nativeTableAll = [];
  public nativeTableSoAll = [];
  // public old_record_id: any = "";
  public old_date: any = "";
  public old_date_stack: any = "";
  public old_so_date: any = "";
  public old_version_base: any = "";
  public old_version_so_base: any = "";
  public old_version_stack: any = "";
  public old_date_base_name: any = "";
  public old_date_name: any = "";
  public old_date_so_name: any = "";
  public old_stack_name: any = "";
  public addValueField(data) {
    if (data) {
      if (data?.functionName == "root") {
        //data.rowKey = `${Math.random()}`
        //data.rowKey = `${data.id}-${data.FunctionLevel}-${data.functionName}`
        data.value = data?.self;
        data.name =
          data?.functionName +
          " " +
          (data?.self / 1024 / 1024).toFixed(2) +
          "MB";
      } else {
        //data.rowKey = `${Math.random()}`
        //data.rowKey = `${data.id}-${data.FunctionLevel}-${data.functionName}`
        data.value = data?.self;
        data.name = data?.functionName;
      }

      if (Array.isArray(data.children)) {
        data.children.forEach((child) => {
          this.addValueField(child);
        });
      }
    }
  }
  public traverse_update_node(node) {
    if (!node.children || node.children.length === 0) {
      return { self: node.self, total: node.total };
    } else {
      let self_total = 0;
      let total_total = 0;
      for (let child of node.children) {
        let {
          self: child_self,
          total: child_total,
        } = this.traverse_update_node(child);
        self_total += child_self;
        total_total += child_total;
      }
      node.self = self_total;
      node.total = total_total;
      // console.log({ self: self_total, total: total_total })
      return { self: self_total, total: total_total };
    }
  }
  public flame_serch = "";
  public labelWallTime = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.flame_function_input === "" && this.flame_so_input.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.flame_function_input) {
        let list = [this.flame_function_input];
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return (
            d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
      if (this.flame_so_input.length > 0) {
        const hasMatchingKeyword = this.flame_so_input.some((v) => {
          return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public labelWallTime_v2 = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (
      this.flame_stack_function_input === "" &&
      this.flame_stack_so_input.length == 0
    ) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.flame_stack_function_input) {
        let list = [this.flame_stack_function_input];
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return (
            d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
      if (this.flame_stack_so_input.length > 0) {
        const hasMatchingKeyword = this.flame_stack_so_input.some((v) => {
          return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        console.log(hasMatchingKeyword);
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public labelWallTime_functions = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.functions_flame === "") {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.functions_flame) {
        let list = this.functions_flame.split(",");
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return (
            d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public labelWallTime_so = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色

    if (this.so_flame.length === 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色

      let list = this.so_flame;
      // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
      const hasMatchingKeyword = list.some((v) => {
        return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      });

      // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      return hasMatchingKeyword ? "#f00" : color;
    }
  };
  public changeView: any = true;
  public labelTime = (d, data) => {
    //  "(" +
    //   (d.parent == null
    //     ? "100%"
    //     : ((d.value / (data as any).value) * 100).toFixed(2) +
    //       "%") +

    //   ")"
    // return `<div><div style="font-size:14px">${d.data.name}</div><div>${d.data.value}</div><div>soName:${d.data.soName}</div></div>`
    // console.log(d)
    return (
      d.data.name +
      "\nsoName:" +
      d.data.soName +
      "\nself:" +
      this.getNum(d.data.value) +
      (d.data.self_diff ? this.diffNum(d.data.self_diff) : "") +
      "\ntotal:" +
      this.getNum(d.data.total) +
      (d.data.self_diff ? this.diffNum(d.data.total_diff) : "")
    );
  };
  public renderFlame(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);

    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(1200)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }

  public renderFlame_v2(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }
    let color_list = [];
    if (selector == "#tree") {
      color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];
    } else if (selector == "#decrease") {
      color_list = ["#6EC3FF", "#FFD15C", "#FF6A5C"];
    } else if (selector == "#increase") {
      color_list = ["#6EC3FF", "#FFD15C", "#4CAF50"];
    }
    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    function getMaxValueByType(data, type) {
      return d3.max(getAllValues(data).filter((d) => d.type === type));
    }
    const maxTreeValue = getMaxValueByType(data, "public");
    const maxDecreaseValue = getMaxValueByType(data, "decrease");
    const maxIncreaseValue = getMaxValueByType(data, "increase");
    const decreaseColorMapper = d3
      .scaleLinear()
      .domain([0, maxDecreaseValue * 0.5, maxDecreaseValue])
      .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

    const increaseColorMapper = d3
      .scaleLinear()
      .domain([0, maxIncreaseValue * 0.5, maxIncreaseValue])
      .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);
    const treeColorMapper = d3
      .scaleLinear()
      .domain([0, maxTreeValue * 0.5, maxTreeValue])
      .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);
    const maxDataValue = d3.max(allValues);

    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(color_list);
    flame
      .width(400)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) => {
        let color;
        if (d.data.type === "public") {
          color = treeColorMapper(d.data.value);
        } else if (d.data.type === "decrease") {
          color = decreaseColorMapper(d.data.value);
        } else if (d.data.type === "increase") {
          color = increaseColorMapper(d.data.value);
        }
        return this.labelWallTime_v2(d, originalColor, color);
      })
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlame_v2_merge(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }
    let color_list = [];

    color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];

    // 获取火焰图数据中的最大值
    const treeRootValue = this.perfettoStack_v2?.tree.self;
    const decreaseRootValue = this.perfettoStack_v2?.decrease.self;
    const increaseRootValue = this.perfettoStack_v2?.increase.self;
    const treeColorMapper = d3
      .scaleLinear()
      .domain([0, treeRootValue * 0.5, treeRootValue])
      .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);
    console.log(treeColorMapper);
    const decreaseColorMapper = d3
      .scaleLinear()
      .domain([0, decreaseRootValue * 0.5, decreaseRootValue])
      .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

    const increaseColorMapper = d3
      .scaleLinear()
      .domain([0, increaseRootValue * 0.5, increaseRootValue])
      .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);

    // 创建颜色映射器
    // const colorMapper = d3
    //   .scaleLinear()
    //   .domain([0, maxDataValue * 0.5, maxDataValue])
    //   .range(color_list);
    flame
      .width(1200)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) => {
        let colorMapper;
        if (d.data.type === "public") {
          colorMapper = treeColorMapper;
        } else if (d.data.type === "decrease") {
          colorMapper = decreaseColorMapper;
        } else if (d.data.type === "increase") {
          colorMapper = increaseColorMapper;
        } else if (d.data.type === "merge") {
          colorMapper = () => "gray";
        }

        // 调用 labelWallTime_v2 函数
        return this.labelWallTime_v2(d, originalColor, colorMapper);
      })
      .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlame_functions(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);

    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(1200)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime_functions(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public renderFlame_so(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);

    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(1200)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime_so(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }

  customTooltip(d) {
    // 在这里自定义你的 tooltip 内容
    // d 是当前 hover 的数据点
    // 返回一个 HTML 字符串，将作为 tooltip 的内容
    return `<div>
       <strong>Label:</strong> ${d.data.name}<br>
       <strong>Value:</strong> ${d.data.value}
      </div>`;
  }
  public handleHover(node, el) {
    const targetElement = d3.selectAll(`g[name='${node.data.name}']`);

    if (node) {
      // 当悬停在方块上时，为目标元素添加 .hovered 类
      targetElement.classed("hovered", true);
    } else {
      // 当悬停离开方块时，删除 .hovered 类
      targetElement.classed("hovered", false);
    }
  }
  public getNum(num) {
    if (num >= 1024 * 1024) {
      return (num / 1024 / 1024).toFixed(2) + "MB";
    } else if (num >= 1024 && num < 1024 * 1024) {
      return (num / 1024).toFixed(2) + "KB";
    } else if (num < 1024) {
      return num.toFixed(2) + "B";
    }
  }
  public diffNum(num) {
    let diff = Math.abs(num);
    let data = this.getNum(diff);
    if (num < 0) {
      return "(-" + data + ")";
    } else {
      return "(+" + data + ")";
    }
  }
  public moudle_trend_loading = false;
  public get module_trend_data() {
    return readGetPerfettoModuleTrend(store);
  }
  public get module_list_data() {
    return readGetPerfettoModuleList(store);
  }
  public async mounted() {
    this.flameLoadingStack = true;
    this.report_loading = true;
    this.moudle_loading = true;
    this.funcLoading = true;
    this.nativeTableAllLoading = true;
    this.flameLoading = true;
    this.moudle_trend_loading = true;
    this.moudle_list_loading = true;
    this.type = this.localProject == 7 ? "1" : "";
    this.type = this.$route.query.typeof ? this.$route.query.typeof : this.type;
    await dispatchPerfettoTypeOptions(store, {
      project: this.localProject,
      is_all: this.type,
    });
    this.type_query = this.$route.query.type
      ? Number(this.$route.query.type)
      : this.perfTypeOptions[0].report_type;
    await dispatchPerfettoOptions(store, {
      project: this.localProject,
      report_type: this.type_query,
      is_all: this.type,
    });
    await dispatchPerfettoSettings(store, {
      project: this.localProject,
    });

    this.base_id = this.settings.perfetto_set.name
      ? this.settings.perfetto_set.name
      : "";

    // this.task_id = this.$route.query.task_record_id
    //   ? Number(this.$route.query.task_record_id)
    //   : this.perfDateOptions[0].task_record_id;
    this.date = this.$route.query.date
      ? this.$route.query.date
      : this.perfDateOptions[0].date;
    this.version = this.$route.query.version
      ? this.$route.query.version
      : this.perfDateOptions[0].version;
    this.date_name = this.perfDateOptions.filter(
      (v) => v.date == this.date && v.version == this.version
    )[0].name;

    if (this.$route.query.old_date) {
      this.old_date = this.$route.query.old_date;
    }
    if (this.$route.query.old_version_base) {
      this.old_version_base = this.$route.query.old_version_base;
    }
    if (this.$route.query.old_date && this.$route.query.old_version_base) {
      this.old_date_name = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].name;
      this.old_date_so_name = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].name;
      this.old_stack_name = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].name;
      this.old_so_date = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].date;
      this.old_version_so_base = this.perfDateOptions.filter(
        (v) => v.date == this.old_date && v.version == this.old_version_base
      )[0].version;
    } else {
      this.old_record_id_created();
      this.old_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].date;
      this.old_date_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].date;
      this.old_version_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_name
      )[0].version;
      this.old_so_date = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].date;
      this.old_version_so_base = this.perfDateOptions.filter(
        (v) => v.name == this.old_date_so_name
      )[0].version;
      this.old_version_stack = this.perfDateOptions.filter(
        (v) => v.name == this.old_stack_name
      )[0].version;
    }
    // else {
    //   this.old_record_id_created();
    // }
    await dispatchPerfettoDeviceOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      report_type: this.type_query,
      is_all: this.type,
    });

    const option = this.perfDeviceOptions.find(item => item.name.includes('J200')) || this.perfDeviceOptions[0]
    this.device_id = this.$route.query.device_id
      ? Number(this.$route.query.device_id)
      : option?.device_id;
    
    await dispatchPerfettoOldOptions(store, {
      project: this.localProject,
      report_type: this.type_query,
      is_all: this.type,
      device_id: this.device_id,
    });
    await dispatchPerfettoReport(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: Number(this.type_query),
      is_all: this.type,
    });
    this.scene_flame =
      this.scene_flame_list?.length > 0 ? this.scene_flame_list[0] : "";
    this.level_flame =
      this.level_flame_list?.length > 0 ? this.level_flame_list[0] : "";
    this.so_scene_flame =
      this.scene_flame_so_list?.length > 0 ? this.scene_flame_so_list[0] : "";
    this.so_level_flame =
      this.level_flame_so_list?.length > 0 ? this.level_flame_so_list[0] : "";
    this.functions_flame = this.level_flame
      ? readGetPerfettoReport(store).func_list[this.scene_flame][
          this.level_flame
        ].join(",")
      : "";
    this.so_flame = this.so_list?.length > 0 ? this.so_list : [];
    // this.functions_flame_api();
    // this.so_flame_api();
    this.report_loading = false;
    this.nativeHead();
    await dispatchPerfettoLevelOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });

    this.level = this.$route.query.level
      ? this.$route.query.level
      : this.perfLeveOptions[0].level;
    this.level_trend = this.$route.query.level_trend
      ? this.$route.query.level_trend
      : this.perfLeveOptions[0].level;
    this.level_func = this.$route.query.level_func
      ? this.$route.query.level_func
      : this.perfLeveOptions[0].level;
    this.level_func_so = this.$route.query.level_func
      ? this.$route.query.level_func
      : this.perfLeveOptions[0].level;
    this.level_all = this.$route.query.level_all
      ? this.$route.query.level_all
      : this.perfLeveOptions[0].level;
    this.level_stack = this.$route.query.level_all
      ? this.$route.query.level_all
      : this.perfLeveOptions[0].level;
    this.level_so = this.$route.query.level_all
      ? this.$route.query.level_all
      : this.perfLeveOptions[0].level;
    this.flame_so = this.$route.query.level_all
      ? this.$route.query.level_all
      : this.perfLeveOptions[0].level;

    await dispatchPerfettoNativeTrend(store, {
      project: this.localProject,
      level: this.level,

      report_type: Number(this.type_query),
      start: "",
      end: "",
      is_all: this.type,
    });
    this.resBase64 = [];

    this.drawNativeTrend(this.device_id, this.level);

    await dispatchPerfettoSceneOptions(store, {
      project: this.localProject,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      is_all: this.type,
    });

    this.scene_id = this.$route.query.scene_id
      ? this.$route.query.scene_id
      : this.loading_created();
    this.scene_func_id = this.$route.query.scene_func_id
      ? this.$route.query.scene_func_id
      : this.loading_created();
    this.scene_func_id_so = this.$route.query.scene_func_id
      ? this.$route.query.scene_func_id
      : this.loading_created();
    this.scene_natvie_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    this.scene_stack_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    this.scene_so_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    this.scene_flame_id = this.$route.query.scene_natvie_id
      ? this.$route.query.scene_natvie_id
      : this.loading_created();
    if (this.localProject === 7) {
      //this.stack_v2_api();
      (this as any).getStackTableData()
      this.module_treand_api();
      this.module_list_api();
    }

    await dispatchPerfettoNativeFuncTrend(store, {
      project: this.localProject,
      level: this.level_func,

      report_type: Number(this.type_query),
      scene_id: this.scene_func_id,
      start: "",
      end: "",
      is_all: this.type,
    });
    this.index_func = this.funcTrend.func_list.filter((v, index) => index <= 4);
    this.drawNativeFuncTrend();
    this.funcLoading = false;
    await dispatchPerfettoSoList(store, {
      project: this.localProject,
      level: this.level_func_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_func_id_so,
      report_type: this.type_query,
      is_all: this.type,
    });
    if (this.funcSoTrend.length > 0) {
      this.index_func_so = this.funcSoTrend.filter((v, index) => index <= 9);
      await dispatchPerfettoSoFuncTrend(store, {
        project: this.localProject,
        level: this.level_func_so,

        report_type: Number(this.type_query),
        scene_id: this.scene_func_id_so,
        start: "",
        end: "",
        so_list: this.index_func_so,
        is_all: this.type,
      });
      this.drawSOFuncTrend();
    }

    this.drawSOFuncTrend();
    await dispatchPerfettoNativeModule(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_id,
      report_type: this.type_query,
      is_all: this.type,
      order_by: this.order_by_detail,
      reverse: this.reverse_detail,
    });

    // this.Native_thread_important();
    this.moudle_loading = false;
    await dispatchPerfettoNativeAll(store, {
      project: this.localProject,
      level: this.level_all,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_natvie_id,
      top: this.top,
      search: this.serch_input,
      old_date: this.old_date,
      old_version: this.old_version_base,
      order_by: "",
      reverse: "",
      is_all: this.type,
    });
    await dispatchPerfettoSoAll(store, {
      project: this.localProject,
      level: this.level_so,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene_so_id,
      top: this.top_so,
      search: this.serch_input_so,
      old_date: this.old_so_date,
      old_version: this.old_version_so_base,
      order_by: "unreleasedSizeDiff",
      reverse: 1,
      is_all: this.type,
    });
    this.nativeTableAll = this.nativeAllData.slice(
      (this.page - 1) * this.size,
      this.page * this.size
    );
    this.nativeTableSoAll = this.nativeAllSoData.slice(
      (this.page_so - 1) * this.size_so,
      this.page_so * this.size_so
    );
    this.nativeTableAllLoading = false;
    await dispatchPerfettoStack(store, {
      project: this.localProject,
      level: this.flame_so,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.type_query,
      scene_name: this.scene_flame_id,
      is_all: this.type,
    });
    if (JSON.stringify(this.perfettoStack) === "{}") {
      this.flameShow = false;
      return;
    } else {
      this.flameShow = true;
      this.flame_check_data = false;
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStack);
      });
    }

    this.flameLoading = false;

    this.$router.push({
      query: {
        ...this.$route.query,
        date: this.date,
        version: this.version,
        old_date: this.old_date,
        old_version_base: this.old_version_base,
        device_id: this.device_id,
        type: this.type_query,
        level: this.level,
        level_trend: this.level_trend,
        level_func: this.level_func,
        level_all: this.level_all,
        scene_id: this.scene_id,
        scene_func_id: this.scene_func_id,
        scene_natvie_id: this.scene_natvie_id,
        typeof: this.type,
        // old_record_id: this.old_record_id,
      },
    });
  }
}
